'use client';

import { useEffect } from 'react';
import { usePaywall } from '@/app_lib/providers/PaywallProvider';

const TRINITY_ID = 2900017491; // not secret

function getPlayerType(paywallCheck: string) {
  return paywallCheck === 'no-paywall' ? '' : 'subscription-locked';
}

function buildScriptSrc(url: string, playerType: string, ownAudio?: string) {
  let src = `https://trinitymedia.ai/player/trinity/${TRINITY_ID}/?pageURL=${encodeURIComponent(
    url,
  )}&FAB=fabAfterClick&playerType=${playerType}`;
  if (ownAudio) {
    src += `&cf=${encodeURIComponent(ownAudio)}`;
  }
  return src;
}

export interface TrinityPlayerProps {
  url: string;
  ownAudio?: string;
  noTrinityAds?: boolean;
}

// NOTE: ownAudio comes from earnings reports

export const TrinityPlayerScript = ({ url, ownAudio, noTrinityAds }: TrinityPlayerProps) => {
  const {
    paywallState: { paywallCheck },
  } = usePaywall();
  useEffect(() => {
    if (window.__TRINITY_SCRIPT_LOADED__) {
      return;
    }

    const trinityRef = document.querySelector('div.impression-element[data-content-placement="trinity_audio_player"]');
    const shouldInitPlayer = paywallCheck !== 'pending' && trinityRef;

    let script: HTMLScriptElement | null = null;

    if (shouldInitPlayer) {
      const playerType = getPlayerType(paywallCheck);
      script = document.createElement('script');
      script.src = buildScriptSrc(url, playerType, ownAudio);
      script.async = true;
      script.type = 'text/javascript';

      if (trinityRef) {
        trinityRef.appendChild(script);
        window.__TRINITY_SCRIPT_LOADED__ = true;
      }
    }
  }, [url, paywallCheck, ownAudio]);

  useEffect(() => {
    const updateTrinityAdStatus = (event: MessageEvent) => {
      if (
        event.origin !== 'https://trinitymedia.ai' ||
        event.data?.type !== 'TRINITY_TTS' ||
        typeof window === 'undefined' ||
        !window.TRINITY_PLAYER ||
        !window.TRINITY_PLAYER.message ||
        !window.TRINITY_PLAYER.api
      ) {
        return;
      }
      if (event.data.value && event.data.value.action === window.TRINITY_PLAYER.message.playerReady && noTrinityAds) {
        window.TRINITY_PLAYER.api.setAdFreeSubscriber();
      }
    };
    window.addEventListener('message', updateTrinityAdStatus);
    return () => {
      window.removeEventListener('message', updateTrinityAdStatus);
    };
  }, [noTrinityAds]);

  return (
    <div
      className='trinity-tts-pb'
      dir='ltr'
    />
  );
};
